import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";
import { TotalAmountCardProps } from "./types";
import { formatDebtCurrency } from "./utils";

/**
 * Displays the total face value of all debt securities in the selected display currency.
 * Requirements: 2.1, 2.5, 2.6, 2.7, 5.4, 5.5
 */
export function TotalAmountCard({
  total,
  currency,
  isLoading,
  hasError,
  unconvertedSummary,
}: TotalAmountCardProps) {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-sm font-medium text-muted-foreground">
          Total Debt Securities Value
        </CardTitle>
      </CardHeader>
      <CardContent>
        {isLoading ? (
          <div aria-busy="true" aria-label="Loading total amount">
            <Skeleton className="h-8 w-48" />
          </div>
        ) : hasError ? (
          <div role="alert" className="space-y-1">
            <p className="text-sm text-destructive">
              Currency conversion unavailable.
            </p>
            {unconvertedSummary && (
              <p className="text-xs text-muted-foreground">{unconvertedSummary}</p>
            )}
          </div>
        ) : (
          <p className="text-2xl font-bold">{formatDebtCurrency(total, currency)}</p>
        )}
      </CardContent>
    </Card>
  );
}
